import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Store } from '@ngrx/store';
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { CustomStockProtectionOverview, CustomStockProtectionOverviewList, CustomStockProtectionScenarioOptions, CustomStockProtectionSortOptions } from '../../custom-stock-potection.models';
import { CustomStockProtectionService } from '../../custom-stock-protection.service';
import { clearStockProtectionOverview, getStockProtectionOverview, searchStockProtection } from '../../store/custom-stock-protection.actions';
import { CustomStockProtectionState } from '../../store/custom-stock-protection.reducer';
import { errorStockProtectionOverview, selectStockProtectionOverview } from '../../store/custom-stock-protection.selectors';

@Component({
    selector: 'app-custom-stock-protection-overview',
    templateUrl: './custom-stock-protection-overview.component.html',
    styleUrls: ['./custom-stock-protection-overview.component.scss'],
    standalone: false
})
export class CustomStockProtectionOverviewComponent implements OnInit {

  @ViewChild('searchForm') searchForm: NgForm;

  stockProtectionOverview$: Observable<CustomStockProtectionOverviewList>  =
  this.store.select(selectStockProtectionOverview);
  errorOverview$: Observable<Error> = this.store.select(errorStockProtectionOverview);

  stockProtectionOverview: CustomStockProtectionOverviewList;
  stockProtections: CustomStockProtectionOverview[];
  errorOverview: Error;

  filterScenarioOptions = Object.keys(CustomStockProtectionScenarioOptions).filter(
    (keys) => typeof keys === 'string'
  ) as string[];
  
  uigArticleNumber: string = '';
  uigProcess: string = '';
  scenario: string = '';
  selectedScenarioOption: string = this.filterScenarioOptions[0];
  fileName = ''; 
  fileToBeImported: File; 

  selectedSortOption: string;
  sortOptions: string[];
  sortDirection: string = 'desc';
  compare = (v1: string | number | Date, v2: string | number | Date) =>
    v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

  constructor(
    private store: Store<CustomStockProtectionState>,
    private stockProtectionService: CustomStockProtectionService,
    private translation: TranslationService,
    private messageService: GlobalMessageService) { }

  ngOnInit(): void {
    this.setSortOptions();
    this.getStockProtectionOverview();

    this.stockProtectionOverview$
      .pipe(
        filter((stockProtectionOverview) => stockProtectionOverview != null),
        tap((stockProtectionOverview) => {
          this.stockProtectionOverview = stockProtectionOverview;
          this.stockProtections = [...stockProtectionOverview.responses];
          this.onChangeSort();
        })
      )
      .subscribe();
      
    this.errorOverview$
      .pipe(
        filter((error) => error != null),
        tap((error) => {
          this.errorOverview = error;
        }),
        switchMap(() => this.translation.translate('customStockProtection.error')),
        tap((text) => {
          this.messageService.add(text, GlobalMessageType.MSG_TYPE_ERROR);
        })
      )
      .subscribe();
  }

  openInstructions(){
    this.stockProtectionService.openInstructions();
  }

  getStockProtectionOverview(): void {
    this.stockProtectionOverview = null;
    this.stockProtections = null;
    this.errorOverview = null;
    this.store.dispatch(getStockProtectionOverview());
  }

  onSubmit() {
    this.uigArticleNumber = this.searchForm.value.uigArticleNumber;
    this.uigProcess = this.searchForm.value.uigProcess;
    this.scenario = CustomStockProtectionScenarioOptions[this.searchForm.value.scenario];
    this.searchStockProtection();
  }

  searchStockProtection(): void {
    this.stockProtectionOverview = null;
    this.stockProtections = null;
    this.errorOverview = null;
    this.store.dispatch(searchStockProtection({
      productCode: this.uigArticleNumber,
      processNumber: this.uigProcess,
      scenarioCode: this.scenario
    }));
  }

  resetForm(): void{
    this.sortDirection = 'desc';
    this.searchForm.resetForm({
      uigArticleNumber: "",
      uigProcess: "",
      scenario: this.filterScenarioOptions[0]
    });
    this.setSortOptions();
    this.getStockProtectionOverview();
  }

  setSortOptions(): void {
      this.selectedSortOption =
      CustomStockProtectionSortOptions[
        CustomStockProtectionSortOptions.processNumber
        ];
      this.sortOptions = Object.values(
        CustomStockProtectionSortOptions
      ).filter((value) => typeof value === 'string') as string[]; 
  }

  onChangeSort(): void {
     this.stockProtections = [...this.stockProtectionOverview.responses].sort((a, b) => {
       if(this.processNumberOrValue(this.selectedSortOption))
       {
        const res = this.compare(
          parseInt(a[this.selectedSortOption]),
          parseInt(b[this.selectedSortOption])
        );
        return this.sortDirection === 'asc' ? res : -res;
       }
       else{
        const res = this.compare(
          a[this.selectedSortOption],
          b[this.selectedSortOption]
        );
        return this.sortDirection === 'asc' ? res : -res;
      }     
    });
  }

  processNumberOrValue (selectedSortOption: string): boolean{
    return (selectedSortOption === String(CustomStockProtectionSortOptions[CustomStockProtectionSortOptions.processNumber]) || 
    selectedSortOption === String(CustomStockProtectionSortOptions[CustomStockProtectionSortOptions.value]));
  }

  openDetails(processNumber: string, productCode: string, inactive: boolean){
    this.stockProtectionService.openDetails(processNumber,productCode,inactive);
  }

  onFileSelected(event: any) {
    this.fileToBeImported = event.target.files[0];
    if (this.fileToBeImported) {
        this.fileName = this.fileToBeImported.name;
    }
  }

  importFile():void{
    if(this.fileToBeImported){
      this.stockProtectionService.importFile(this.fileToBeImported);
    }
    this.fileToBeImported = null;
    this.fileName = ''; 
  }
  
  ngOnDestroy(): void {
    this.store.dispatch(clearStockProtectionOverview());
  }
}
